import { IPublishTermsResponse } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { getSelectedServiceId } from './getSelectedServiceId';
import { getServices } from './getServices';
import { getServiceId } from '../../../../utils/publishTerms';
import { mapServices } from './mapServices';
import { mapAuction } from './mapAuction';
import { mapCalltracking } from './mapCalltracking';
import { getPackageId } from './getPackageId';
import { mapPackages } from './mapPackages';
import { getSelectedPackageId } from './getSelectedPackageId';
import { mapMultiposting } from './mapMultiposting';
import { mapPeriodsByService } from './mapPeriodsByService';
import { getSelectedPeriodId } from './getSelectedPeriodId';
import { mapPublication } from './mapPublication';
import { getDiffPricing } from './getDiffPricing';
import { mapRecommendedPackage } from './mapRecommendedPackage';
import { IPublishTermsSuccessPayload } from '../../../../redux/types/publishTermsPayload';
import { EPlacingType } from '../../../../redux/reducers';

export const mapPublishTerms = (response: IPublishTermsResponse): IPublishTermsSuccessPayload => {
  const message = response.message || null;

  const rawPackages = response.servicePackages || [];
  const rawRecommendedPackages = response.recommendedServicePackages || [];

  const packageIds = rawPackages.map(getPackageId);
  const packages = mapPackages(rawPackages);
  const selectedPackageId = getSelectedPackageId(rawPackages);

  const terms = getServices(response);
  const serviceIds = terms.map(term => getServiceId(term.services));
  const services = mapServices(terms);
  const selectedServiceId = getSelectedServiceId(terms);

  const periodsByService = mapPeriodsByService(terms);
  const selectedPeriodId = getSelectedPeriodId(terms, selectedServiceId);

  const auction = mapAuction(response.auction);
  const calltracking = mapCalltracking(response.calltracking);
  const publication = mapPublication(response.publication);

  const selectedPlacingType = response.isAllowPackage ? EPlacingType.package : EPlacingType.balance;

  const recommendedPackages = rawRecommendedPackages.map(mapRecommendedPackage);

  const { isMultipostingAvailable, multipostingABGroup } = mapMultiposting(response);

  const termsDurations = response.auction?.durations || [];

  const withoutMinimalBet = response.withoutMinimalBet ?? false;
  const withoutPromotion = response.auction?.withoutPromotion ?? false;

  const moneySource = response.moneySource;

  const diffPricing = getDiffPricing(periodsByService, publication);

  const highDemandCoefficient = response.highDemandCoefficient;

  const publishTerms = {
    serviceIds,
    services,
    selectedServiceId,
    promotionServiceId: null,
    message,
    isMultipostingAvailable,
    multipostingABGroup,
    packageIds,
    packages,
    selectedPackageId,
    periodsByService,
    selectedPeriodId,
    selectedPlacingType,
    publication,
    diffPricing,
    highDemandCoefficient,
  };

  return {
    publishTerms,
    auction,
    calltracking,
    recommendedPackages,
    termsDurations,
    withoutMinimalBet,
    withoutPromotion,
    moneySource,
  };
};
